/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuthUserProvider {
    DATABASE = 'Database',
    ACTIVE_DIRECTORY = 'ActiveDirectory',
}
